///////////////////////////////////////////////////

import { cpOrderFormApiConnector } from 'apiConnector/secondary-market/cp-order/form';
import { ofType } from 'redux-observable';
import { of } from 'rxjs';
import { catchError, map, mergeMap, takeUntil } from 'rxjs/operators';
import { secondaryMarketCpOrderReloadFormFetchedThunk } from 'state/secondaryMarket/cpOrder/cpOrderForm/cpOrderForm.thunks';
import { secondaryMarketCpOrderReloadFormFetchedFailed } from 'state/secondaryMarket/cpOrder/referential/product/product.actions';
import type { EpicWithThunk } from 'state/state.common';
import { mapErrorKind } from 'utils/errors/errors';
import type { HttpError } from 'utils/http/httpClient.model';

import { getTabRemoved$ } from '../utils';

export function reloadCpOrderFormEpic(): EpicWithThunk {
  return (actions$, _state$, { httpClient }) => {
    const { reload } = cpOrderFormApiConnector(httpClient);

    return actions$.pipe(
      ofType('SECONDARY_MARKET_CP_ORDER_RELOAD_FORM_FETCH_REQUESTED'),
      mergeMap(({ request, tabId, workspace }) => {
        if (request.bcsProductKey === undefined || request.bcsProductKey === null) {
          return of(
            secondaryMarketCpOrderReloadFormFetchedFailed(
              tabId,
              workspace,
              'BCS product key is missing from tab content',
            ),
          );
        }
        return reload(request).pipe(
          takeUntil(getTabRemoved$(actions$, tabId)),
          map(response => secondaryMarketCpOrderReloadFormFetchedThunk(tabId, workspace, response)),
          catchError((err: HttpError) =>
            of(
              secondaryMarketCpOrderReloadFormFetchedFailed(tabId, workspace, err?.payload?.message, mapErrorKind(err)),
            ),
          ),
        );
      }),
    );
  };
}
